(function ($, Global) {
    var aboOfferOffsets = [];
    var loopOffers;

    function MenuTopComponent() {
        // Déclaration class objet
    }
    MenuTopComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    }

    MenuTopComponent.prototype.publishers = function () {
        var self = this;

        $(document).ready(function () {
			if ($('.menutop .abo-offer.in').exists()) {
				$('.menutop .abo-offer.in').first().addClass('active');
                $.Topic('init-carousel-offers').publish();
            }
        });
        $(Global).smartResize(function () {
            $.Topic('init-carousel-offers').publish();
        }, 300);

        $(document).on('click', '.abo-offer', function () {
            var offreId = $(this).attr('data-offreid');

            $(this).removeClass('in');
            Cookie.remove('TPMessageNoShow');
            $('.bloc-abo[data-offreid="' + offreId + '"]').addClass('in');
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        });
    }

    MenuTopComponent.prototype.subscribers = function () {
        $.Topic('init-carousel-offers').subscribe(function () {
            var interval = $('.menutop .navbar-text').data('carousel-interval') || 3000;
            var $container = $('.menutop .navbar-text');
            var isAllOffers = $('.headroom--not-top').exists();
            var $aboOffers = $container.find('.abo-offer' + (isAllOffers ? '' : '.in'));

            $container.animate({ scrollLeft: 0 }, 0);

            aboOfferOffsets = $aboOffers.toArray().map(function (element) {
                var $el = $(element);
                var margin = $el.outerWidth(true) - $el.innerWidth();
                return $el.offset().left + ($el.innerWidth() / 2) - $container.offset().left - margin / 2;
            });

            moveToOfferActive($container, aboOfferOffsets[0]);

            clearInterval(loopOffers);
            loopOffers = setInterval(nextOffer($container, $aboOffers), interval);
        });
    };

    function nextOffer($container, $offers) {
        return function () {
            var $offerActive = $container.find('.abo-offer.active');
            var offerActiveIndex = $offers.index($offerActive);
            var nextIndex = (offerActiveIndex + 1 == $offers.length) ? 0 : offerActiveIndex + 1;
            var $nextOffer = $offers.eq(nextIndex);

            $offerActive.removeClass('active');
            $nextOffer.addClass('active');

            moveToOfferActive($container, aboOfferOffsets[nextIndex]);
        }
    }

    function moveToOfferActive($container, offset) {
        $container.animate({
            scrollLeft: offset
        });
    }

    Global.MenuTopComponent = MenuTopComponent;
}(jQuery, window));